// Tab Module
const tabLinks = document.querySelectorAll('.tab-module__nav-link');
tabLinks.forEach((element) => {
  element.addEventListener('click', (ev) => {
    const targetId = ev.target.getAttribute('data-id');
    const parent = ev.target.closest('.tab-module__inner');

    parent.querySelector('.is-active').classList.remove('is-active');
    parent.querySelector('.is-open').classList.remove('is-open');

    ev.target.classList.add('is-active');

    const targetElement = document.getElementById(targetId);
    targetElement?.classList.add('is-open');
  });
});
